/* eslint-disable prettier/prettier */
import { Select } from 'antd';
import { useState, useEffect } from 'react';
import { FileService } from '../../services/file.service';
import { X, Save, Loader2 } from 'lucide-react';
import { CustomSelect } from './Select';

const { Option } = Select;

interface CedantNameEditorProps {
  cedantId: string;
  currentName: string;
  onSave: (newCedantId: string) => void;
  onCancel: () => void;
  treatyId: string;
}

export const CedantNameEditor: React.FC<CedantNameEditorProps> = ({
  cedantId,
  currentName,
  onSave,
  onCancel,
  treatyId,
}) => {
  const [allCedants, setAllCedants] = useState<any[]>([]);
  const [selectedCedant, setSelectedCedant] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    FileService.getCedants()
      .then((res) => {
        setAllCedants(res.data);
      })
      .catch((err) => {
        console.error('Failed to fetch cedants', err);
      });
  }, []);

  const handleSelectCedant = (cedantId: string) => {
    const selected = allCedants.find((cedant) => cedant.id === cedantId);
    setSelectedCedant(selected);
  };

  const handleSave = async () => {
    if (!selectedCedant) {
      return;
    }
    try {
      setIsLoading(true);
      await FileService.updateCedantInTreaty({
        treatyId: treatyId,
        oldCedantId: cedantId,
        newCedantId: selectedCedant.id,
      });
      onSave(selectedCedant.id);
    } catch (error) {
      console.error('Failed to save the cedant:', error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="flex items-center gap-4">
      <CustomSelect
        data={allCedants.map((c) => ({ label: c.name, value: c.id }))}
        value={selectedCedant?.id || cedantId}
        onChange={(id) => {
          const selected = allCedants.find((c) => c.id === id);
          setSelectedCedant(selected);
        }}
      />

      <button onClick={onCancel} disabled={isLoading}>
        <X className="w-5 h-5 font-bold text-red-500 cursor-pointer" />
      </button>
      <button onClick={handleSave} disabled={isLoading}>
        {isLoading ? (
          <Loader2 className="w-5 h-5 animate-spin text-primary" />
        ) : (
          <Save className="w-5 h-5 cursor-pointer text-primary" />
        )}
      </button>
    </div>
  );
};
